export default __webpack_public_path__ + "static/media/N325YZ-Outside.e7c7c944.png";